
export class notification
{
    id:number;
    estatus:string;
    cantidad:number;

    constructor(id:number,
        estatus:string,
        cantidad:number)
    {
        this.id=id;
        this.estatus=estatus;
        this.cantidad=cantidad
    }
}

export const NotiInicial:notification[]=
[
    {
        id: 0,
        estatus: "Ordenes Listas",
        cantidad: 0
    },
    {
        id: 1,
        estatus: "Ordenes Pendientes",
        cantidad: 0
    },
    {
        id: 2,
        estatus: "Ordenes Retenidas",
        cantidad: 0
    },
    {
        id: 3,
        estatus: "Ordenes Total",
        cantidad: 0
    },
    {
        id: 4,
        estatus: "Ordenes Sin Factura",
        cantidad: 0
    }
]